module.exports = __webpack_public_path__ + "media/images/flags/16/Ireland-8b7bf8413788d3c923ebb432f5e29fcb.png";